import TalentSidebar from "./TalentSidebar_updated";
import UserSidebar from "./UserSidebar_upated";
import { useCurrentTalentProfile } from "../hooks";
import useCurrentGTP from "../hooks/useGTP";

type AppSidebarProps = {
  open: boolean;
  setDrawerOpen: (open: boolean) => void;
};

export default function AppSidebar({ open, setDrawerOpen }: AppSidebarProps) {
  const { currentProfile } = useCurrentTalentProfile();

  const handleClose = () => {
    setDrawerOpen(false);
  };

  const { currentGTP } = useCurrentGTP();

  // return currentProfile ? (
  //   <TalentSidebar open={open} handleClose={handleClose} />
  // ) : (
  //   <UserSidebar open={open} handleClose={handleClose} />
  // )

  return currentProfile ? (
    <TalentSidebar open={open} handleClose={handleClose} />
  ) : (
    <UserSidebar open={open} handleClose={handleClose} />
  );
}
